module.exports = __webpack_public_path__ + "img/l13.4d19f43b.png";